<template>
<v-card outlined>
    <v-card-title>Juegos</v-card-title>
    <v-card-text>
        <v-card
            v-for="(juego, index) in list" 
            :key="`juego-${juego.id}-${index}`"
            class="mr-3 mb-5"
            elevation="15"
            >
            <v-card-title>
                {{ juego.name }}
            </v-card-title>
            <v-card-text>
                <div>
    
                </div>
            </v-card-text>
            <v-card-actions>
                <v-expansion-panels flat>
                    <v-expansion-panel >
                        <v-expansion-panel-header>Divisas</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <CupoCrud context="comercializadora" :divisaList="juego.availableDivisaList" :owner="{
                                comercializadora_id: comercializadora.id,
                                juego_id: juego.id,
                            }"/>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card-actions>
        </v-card>
    </v-card-text>
</v-card>
</template>
<script>
import JuegoService from '@services/loteria/JuegoService';

import CupoCrud from '@components/entities/comercio/cupo/crud.vue';

export default {
    components: {
        CupoCrud,
    },
    props: ['comercializadora'],
    data: function () {
        return {
            options: {},
            loading: false,
            list: [],
            count: 0,

            isModalOpen: false,
            item: null,

            params: {
                'limit': 100,
                'offset': 0,
            }
        };
    },
    mounted: function () {
        this.getList();
    },
    methods: {
        getList: function (params = {}) {
            this.loading = true;
            JuegoService
                .getForCupoComercializadora(this.comercializadora.id, { ...this.params, ...params})
                .then(({juegoList, juegoCount}) => {
                    this.list = juegoList;
                    this.count = juegoCount;
                }).finally(() => {
                    this.loading = false;
                });
        },
        add: function () {
            this.item = null;
            this.isModalOpen = true;
        },
        edit: function (item) {
            this.item = item;
            this.isModalOpen = true;
        }
    },
}
</script>